/**
 * 英语定制学习计划（与 FRONTEND-AI-API 契约对齐）
 * 档案 / 计划 / 测评；章节出题与作答仍用 course.js 的 questionList、submitAnswer
 */
import request from '@/utils/request'

/** 学习阶段与年级选项（POST /course/learning_profile/options，免登录） */
export function profileOptions (data = {}) {
  return request({
    url: '/course/learning_profile/options',
    method: 'post',
    data
  })
}

/** 当前学习档案（POST /course/learning_profile/detail；含 current_course_id 等） */
export function profileDetail (data = {}) {
  return request({
    url: '/course/learning_profile/detail',
    method: 'post',
    data
  })
}

/** 保存学习档案（POST /course/learning_profile/save，参数: stage_id、grade_id） */
export function profileSave (data = {}) {
  return request({
    url: '/course/learning_profile/save',
    method: 'post',
    data
  })
}

/**
 * 推荐课程列表（POST /course/learning_plan/recommend_list，参数: stage_id、grade_id、page、page_size）
 * 首页「我的课程」区块与选完阶段/更换课程弹层共用（按当前学段筛选）
 */
export function recommendList (data = {}) {
  return request({
    url: '/course/learning_plan/recommend_list',
    method: 'post',
    data
  })
}

/** 我的课程完整列表页（POST /course/learning_plan/my_course_list，参数: page、page_size） */
export function myCourseList (data = {}) {
  return request({
    url: '/course/learning_plan/my_course_list',
    method: 'post',
    data
  })
}

/** 添加课程（POST /course/learning_plan/course_add，参数: course_id；幂等） */
export function courseAdd (data = {}) {
  return request({
    url: '/course/learning_plan/course_add',
    method: 'post',
    data
  })
}

/** 移除课程（POST /course/learning_plan/course_remove，参数: course_id；停用计划、不删历史） */
export function courseRemove (data = {}) {
  return request({
    url: '/course/learning_plan/course_remove',
    method: 'post',
    data
  })
}

/** 计划详情（POST /course/learning_plan/plan_detail，参数: course_id） */
export function planDetail (data = {}) {
  return request({
    url: '/course/learning_plan/plan_detail',
    method: 'post',
    data
  })
}

/** 保存计划（POST /course/learning_plan/plan_save，参数: course_id、daily_new_count、daily_review_count、rebuild_today） */
export function planSave (data = {}) {
  return request({
    url: '/course/learning_plan/plan_save',
    method: 'post',
    data
  })
}

/** 首页聚合（POST /course/learning_plan/dashboard，参数: course_id 可选；无 course_id 时优先持久化 current_course_id，失效则回退最近活动课程） */
export function planDashboard (data = {}) {
  return request({
    url: '/course/learning_plan/dashboard',
    method: 'post',
    data
  })
}

/**
 * 切换首页当前学习计划课程（POST /course/learning_plan/course_switch，参数: course_id）
 * 仅允许已加入我的课程且计划启用的课程；成功 data 与 dashboard 同构；失败 msg 如「课程未加入我的课程或计划未启用」
 */
export function courseSwitch (data = {}) {
  return request({
    url: '/course/learning_plan/course_switch',
    method: 'post',
    data
  })
}

/** 重新学习（POST /course/learning_plan/restart，参数: course_id） */
export function planRestart (data = {}) {
  return request({
    url: '/course/learning_plan/restart',
    method: 'post',
    data
  })
}

/** 保存测评标记（POST /course/learning_assessment/mark，参数: course_id、items[]） */
export function assessmentMark (data = {}) {
  return request({
    url: '/course/learning_assessment/mark',
    method: 'post',
    data
  })
}

/**
 * 上次测评回显（POST /course/learning_assessment/last_detail）
 * 参数: course_id、page、page_size；
 * 可选 result（int）：按上次测评结果过滤 —— 1=不认识 2=不熟悉 3=已掌握；缺省 / 0 / null 表示全部（不过滤）
 * 可选 filter_basic_words：1 开启并保存 / 0 关闭并保存；不传则读取该用户-课程已保存状态（勿用旧别名 basic_word_switch / exclude_basic_words）
 * 响应含 filter_basic_words（0|1）、assessment（total_count / remaining_count / unknown_count / unfamiliar_count / mastered_count）、data、total
 */
export function assessmentLastDetail (data = {}) {
  return request({
    url: '/course/learning_assessment/last_detail',
    method: 'post',
    data
  })
}

/** 测评历史（POST /course/learning_assessment/history，参数: course_id、page、page_size） */
export function assessmentHistory (data = {}) {
  return request({
    url: '/course/learning_assessment/history',
    method: 'post',
    data
  })
}

/**
 * 测评详情（POST /course/learning_assessment/detail）
 * 参数: assessment_id、page、page_size；
 * 可选 result（int）：1=不认识 2=不熟悉 3=已掌握；缺省 / 0 / null 表示全部
 */
export function assessmentDetail (data = {}) {
  return request({
    url: '/course/learning_assessment/detail',
    method: 'post',
    data
  })
}
